"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contract = void 0;
/**
 * oRPC contract definitions for admin, adminV2, and system routes.
 *
 * Every procedure declares its HTTP method, path, input schema, and an
 * output schema. Some legacy routes still use generic outputs, but we
 * tighten them incrementally as shared server/dashboard contracts become
 * explicit.
 */
const contract_1 = require("@orpc/contract");
const zod_1 = require("zod");
__exportStar(require("./schemas"), exports);
const schemas_1 = require("./schemas");
// ─── Admin V1 ──────────────────────────────────────────────────────
const admin = contract_1.oc.router({
    // Auth
    login: contract_1.oc
        .route({ method: "POST", path: "/admin/v1/login-with-otp" })
        .input(schemas_1.AdminLoginInputSchema)
        .output(schemas_1.AdminGenericResponseSchema),
    refresh: contract_1.oc
        .route({ method: "POST", path: "/admin/v1/refresh" })
        .input(schemas_1.AdminRefreshInputSchema)
        .output(schemas_1.AdminGenericResponseSchema),
    // Top-up
    topup: contract_1.oc.router({
        retryCrypto: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/retry-topup-crypto/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        retryBank: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/retry-topup-bank/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        reject: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/reject-topup" })
            .input(schemas_1.AdminRejectTopUpInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/topup-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Redeem
    redeem: contract_1.oc.router({
        bank: contract_1.oc.router({
            approve: contract_1.oc
                .route({ method: "POST", path: "/admin/v1/approve-redeem-bank/{uuid}" })
                .input(schemas_1.AdminApproveRedeemBankInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            reject: contract_1.oc
                .route({ method: "POST", path: "/admin/v1/reject-redeem-bank/{uuid}" })
                .input(schemas_1.AdminRejectRedeemInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            list: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/redeem-bank-list" })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminGenericResponseSchema),
        }),
        crypto: contract_1.oc.router({
            retry: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/retry-redeem-crypto/{uuid}",
            })
                .input(schemas_1.AdminUuidParamSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            reject: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/reject-redeem-crypto/{uuid}",
            })
                .input(schemas_1.AdminRejectRedeemInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            list: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/redeem-crypto-list" })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminGenericResponseSchema),
        }),
        retryUnknown: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/retry-redeem-unknown/{uuid}",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Transaction
    transaction: contract_1.oc.router({
        getOne: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/transaction/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Freeze
    freeze: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/freeze-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminFreezeListResponseSchema),
        get: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/freeze/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminFreezeDetailSchema),
        submit: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/freeze" })
            .input(schemas_1.AdminSubmitFreezeInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        approve: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/approve-freeze/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        reject: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/reject-freeze/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Mint
    mint: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/mint-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminMintListResponseSchema),
        addressSuggestion: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/mint-address-suggestion" })
            .output(schemas_1.AdminMintAddressSuggestionListResponseSchema),
        get: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/mint/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminMintDetailSchema),
        request: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/mint" })
            .input(schemas_1.AdminMintRequestInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        approve: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/approve-mint/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        reject: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/reject-mint/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        updateStatus: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/update-mint-status/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Merchant
    merchant: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/merchants" })
            .input(schemas_1.AdminListQuerySchema.optional())
            .output(schemas_1.AdminMerchantListResponseSchema),
        get: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/merchant/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminMerchantSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/merchant" })
            .input(schemas_1.AdminAddMerchantInputSchema)
            .output(schemas_1.AdminMerchantSchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/merchant" })
            .input(schemas_1.AdminEditMerchantInputSchema)
            .output(schemas_1.AdminMerchantSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/admin/v1/merchant/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // Currency
    currency: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/currencies" })
            .input(schemas_1.AdminListQuerySchema.optional())
            .output(schemas_1.AdminCurrencyListResponseSchema),
        get: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/currency/{id}" })
            .input(schemas_1.AdminIdParamSchema)
            .output(schemas_1.AdminCurrencySchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/currency" })
            .input(schemas_1.AdminAddCurrencyInputSchema)
            .output(schemas_1.AdminCurrencySchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/currency" })
            .input(schemas_1.AdminEditCurrencyInputSchema)
            .output(schemas_1.AdminCurrencySchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/admin/v1/currency/{id}" })
            .input(schemas_1.AdminIdParamSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
        toggleFlag: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/currency/toggle-flag" })
            .input(schemas_1.AdminToggleCurrencyFlagInputSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // ckBTC
    ckbtc: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ckbtc-transactions" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ckbtc-transaction/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        disburse: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/ckbtc-transaction/{uuid}/disburse",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        revalidate: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/ckbtc-transaction/{uuid}/revalidate",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        changeStatus: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/ckbtc-transaction/change-status",
        })
            .input(schemas_1.AdminChangeCkBtcStatusInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Fireblocks
    fireblocks: contract_1.oc.router({
        hideVault: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/fireblocks/hide-vault" })
            .input(schemas_1.AdminHideVaultInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        unhideVault: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/fireblocks/unhide-vault" })
            .input(schemas_1.AdminHideVaultInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        resendWebhooksById: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/fireblocks/resend-webhooks-by-id",
        })
            .input(schemas_1.AdminResendFireblocksWebhookByIDInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        resendWebhooks: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/fireblocks/resend-webhooks",
        })
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Settlement
    settlement: contract_1.oc.router({
        ctf: contract_1.oc.router({
            list: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/settlement/ctf" })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminGenericResponseSchema),
            detail: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/settlement/ctf/{uuid}" })
                .input(schemas_1.AdminUuidParamSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            summarize: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/settlement/ctf/summarize",
            })
                .input(schemas_1.AdminSettlementSummarizeInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            bulkUpdate: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/settlement/ctf/bulk-update",
            })
                .input(schemas_1.AdminUpdateSettlementCTFInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
        }),
        ftc: contract_1.oc.router({
            list: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/settlement/ftc" })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminGenericResponseSchema),
            detail: contract_1.oc
                .route({ method: "GET", path: "/admin/v1/settlement/ftc/{uuid}" })
                .input(schemas_1.AdminUuidParamSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            summarize: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/settlement/ftc/summarize",
            })
                .input(schemas_1.AdminSettlementSummarizeInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
            bulkUpdate: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v1/settlement/ftc/bulk-update",
            })
                .input(schemas_1.AdminUpdateSettlementFTCInputSchema)
                .output(schemas_1.AdminGenericResponseSchema),
        }),
        resendWebhooks: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/settlement/resend-webhooks",
        })
            .input(schemas_1.AdminResendSettlementWebhooksInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Payment Link
    paymentLink: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/payment-links" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/payment-link/{payment_uuid}" })
            .input(schemas_1.AdminPaymentLinkDetailInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        returnDeposit: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/payment-link/return-deposit",
        })
            .input(schemas_1.AdminReturnDepositInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Standalone admin endpoints
    getDPBalance: contract_1.oc
        .route({ method: "GET", path: "/admin/v1/dp-balance" })
        .input(schemas_1.AdminGetDPBalanceInputSchema)
        .output(schemas_1.AdminGenericResponseSchema),
    transferKyc: contract_1.oc
        .route({ method: "POST", path: "/admin/v1/transfer-kyc" })
        .input(schemas_1.AdminTransferKycInputSchema)
        .output(schemas_1.AdminGenericResponseSchema),
    retryReferralReward: contract_1.oc
        .route({
        method: "POST",
        path: "/admin/v1/retry-referral-reward/{uuid}",
    })
        .input(schemas_1.AdminUuidParamSchema)
        .output(schemas_1.AdminGenericResponseSchema),
    // TON
    ton: contract_1.oc.router({
        prefunder: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ton-prefunder" })
            .output(schemas_1.AdminTonPrefunderListResponseSchema),
    }),
    // Blacklisted Destination
    blacklistedDestination: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/blacklisted-destinations" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminBlacklistedDestinationListResponseSchema),
        detail: contract_1.oc
            .route({
            method: "GET",
            path: "/admin/v1/blacklisted-destination/{uuid}",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminBlacklistedDestinationSchema),
        add: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/blacklisted-destination",
        })
            .input(schemas_1.AdminAddBlacklistedDestinationInputSchema)
            .output(schemas_1.AdminBlacklistedDestinationSchema),
        delete: contract_1.oc
            .route({
            method: "DELETE",
            path: "/admin/v1/blacklisted-destination/{uuid}",
        })
            .input(schemas_1.AdminDeleteBlacklistedDestinationInputSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // Transfer P2P
    transferP2P: contract_1.oc.router({
        crossNetworkList: contract_1.oc
            .route({
            method: "GET",
            path: "/admin/v1/transfer-p2p/cross-network",
        })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/transfer-p2p/{uuid}" })
            .input(schemas_1.AdminTransferP2PDetailInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        retryMinting: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/transfer-p2p/{uuid}/retry-minting",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Captcha
    captcha: contract_1.oc.router({
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/captcha-requirement" })
            .input(schemas_1.AdminAddCaptchaRequirementInputSchema)
            .output(schemas_1.AdminCaptchaRequirementMutationResponseSchema),
        update: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/captcha-requirement" })
            .input(schemas_1.AdminUpdateCaptchaRequirementInputSchema)
            .output(schemas_1.AdminCaptchaRequirementMutationResponseSchema),
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/captcha-requirements" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminCaptchaRequirementListResponseSchema),
        detail: contract_1.oc
            .route({
            method: "GET",
            path: "/admin/v1/captcha-requirement/{id}",
        })
            .input(schemas_1.AdminDetailCaptchaRequirementInputSchema)
            .output(schemas_1.AdminCaptchaRequirementDetailResponseSchema),
    }),
    // Announcement
    announcement: contract_1.oc.router({
        create: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/announcement" })
            .input(schemas_1.AdminCreateAnnouncementInputSchema)
            .output(schemas_1.AdminAnnouncementMutationResponseSchema),
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/announcements" })
            .input(schemas_1.AdminListQuerySchema.optional())
            .output(schemas_1.AdminAnnouncementListResponseSchema),
        update: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/announcement" })
            .input(schemas_1.AdminUpdateAnnouncementInputSchema)
            .output(schemas_1.AdminAnnouncementMutationResponseSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/admin/v1/announcement/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminActionResponseSchema),
    }),
    // Permission
    permission: contract_1.oc.router({
        templateList: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/permission-templates" })
            .input(schemas_1.AdminListQuerySchema.optional())
            .output(schemas_1.AdminPermissionTemplateListResponseSchema),
        templateCreate: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/permission-template" })
            .input(schemas_1.AdminPermissionTemplateInputSchema)
            .output(schemas_1.AdminPermissionTemplateMutationResponseSchema),
        templateUpdate: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/permission-template/{uuid}" })
            .input(schemas_1.AdminUpdatePermissionTemplateInputSchema)
            .output(schemas_1.AdminPermissionTemplateMutationResponseSchema),
        templateDelete: contract_1.oc
            .route({
            method: "DELETE",
            path: "/admin/v1/permission-template/{uuid}",
        })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminActionResponseSchema),
    }),
    // User Restrictions
    userRestrictions: contract_1.oc.router({
        get: contract_1.oc
            .route({
            method: "GET",
            path: "/admin/v1/user-restrictions/{public_address}",
        })
            .input(schemas_1.AdminPublicAddressParamSchema)
            .output(schemas_1.AdminUserRestrictionsResponseSchema),
        update: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/user-restrictions" })
            .input(schemas_1.AdminUserRestrictionsInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        delete: contract_1.oc
            .route({
            method: "DELETE",
            path: "/admin/v1/user-restrictions/{public_address}",
        })
            .input(schemas_1.AdminPublicAddressParamSchema)
            .output(schemas_1.AdminDeleteUserRestrictionsResponseSchema),
        assignPermissions: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/user-permissions/assign",
        })
            .input(schemas_1.AdminAssignPermissionListInputSchema)
            .output(schemas_1.AdminAssignPermissionListResponseSchema),
    }),
    // E-wallet
    ewallet: contract_1.oc.router({
        list: contract_1.oc
            .route({
            method: "GET",
            path: "/admin/v1/ewallets",
        })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminEwalletAccountListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/ewallets/{publicAddress}" })
            .input(schemas_1.AdminAddEWalletInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        delete: contract_1.oc
            .route({
            method: "DELETE",
            path: "/admin/v1/ewallets/{publicAddress}/{ewalletUuid}",
        })
            .input(schemas_1.AdminDeleteEWalletInputSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // Escrow
    escrow: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/escrow-requests" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/escrow/{uuid}" })
            .input(schemas_1.AdminEscrowUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        reject: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/escrow/{uuid}/reject" })
            .input(schemas_1.AdminEscrowUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        dispatch: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/escrow/{uuid}/dispatch" })
            .input(schemas_1.AdminEscrowUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        manualBurn: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v1/escrow/{uuid}/manual-burn",
        })
            .input(schemas_1.AdminEscrowUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // PPOB
    ppob: contract_1.oc.router({
        transactionList: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ppob/transactions" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        transactionDetail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ppob/transaction/{uuid}" })
            .input(schemas_1.AdminPpobTransactionUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        syncPricelist: contract_1.oc
            .route({ method: "POST", path: "/admin/v1/ppob/sync-pricelist" })
            .output(schemas_1.AdminGenericResponseSchema),
        productList: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ppob/products" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        productDetail: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/ppob/product/{id}" })
            .input(schemas_1.AdminPpobProductIdInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        productUpdate: contract_1.oc
            .route({ method: "PUT", path: "/admin/v1/ppob/product/{id}" })
            .input(schemas_1.AdminPpobProductUpdateInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // KYC
    kyc: contract_1.oc.router({
        userList: contract_1.oc
            .route({ method: "GET", path: "/admin/v1/kyc/users" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminKycUserListResponseSchema),
    }),
});
// ─── Admin V2 ──────────────────────────────────────────────────────
const adminV2 = contract_1.oc.router({
    // Redeem
    redeem: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/redeem-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/redeem/{uuid}" })
            .input(schemas_1.AdminV2RedeemUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        approve: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/redeem/{uuid}/approve" })
            .input(schemas_1.AdminV2RedeemUuidInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        reject: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/redeem/{uuid}/reject" })
            .input(schemas_1.AdminV2RedeemRejectInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Bank Top-up
    bankTopup: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/bank-topup-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminGenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/bank-topup/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Fireblocks
    fireblocks: contract_1.oc.router({
        resendById: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/fireblocks/resend-by-id" })
            .input(schemas_1.AdminV2FireblocksResendByIdInputSchema)
            .output(schemas_1.AdminGenericResponseSchema),
        resendFailed: contract_1.oc
            .route({
            method: "POST",
            path: "/admin/v2/fireblocks/resend-failed",
        })
            .output(schemas_1.AdminGenericResponseSchema),
    }),
    // Spread
    spread: contract_1.oc.router({
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/spread" })
            .input(schemas_1.AdminV2SpreadAddInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/spread" })
            .input(schemas_1.AdminListQuerySchema.optional())
            .output(schemas_1.AdminSpreadListResponseSchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/admin/v2/spread/{uuid}" })
            .input(schemas_1.AdminV2SpreadEditInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/admin/v2/spread/{uuid}" })
            .input(schemas_1.AdminUuidParamSchema)
            .output(schemas_1.AdminActionResponseSchema),
        bulkEdit: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/spread/bulk-edit" })
            .input(schemas_1.AdminV2SpreadBulkEditInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
    }),
    // User Limit
    userLimit: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/user-limits" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminUserLimitListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/user-limit" })
            .input(schemas_1.AdminV2UserLimitAddInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/user-limit/{id}" })
            .input(schemas_1.AdminV2UserLimitIdInputSchema)
            .output(schemas_1.AdminUserLimitSchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/admin/v2/user-limit/{id}" })
            .input(schemas_1.AdminV2UserLimitEditInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/admin/v2/user-limit/{id}" })
            .input(schemas_1.AdminV2UserLimitIdInputSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // Event Referral
    eventReferral: contract_1.oc.router({
        programs: contract_1.oc.router({
            create: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v2/event-referral/programs",
            })
                .input(schemas_1.AdminV2EventReferralProgramCreateInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
            list: contract_1.oc
                .route({
                method: "GET",
                path: "/admin/v2/event-referral/programs",
            })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminReferralProgramListResponseSchema),
            detail: contract_1.oc
                .route({
                method: "GET",
                path: "/admin/v2/event-referral/programs/{id}",
            })
                .input(schemas_1.AdminV2EventReferralProgramIdInputSchema)
                .output(schemas_1.AdminReferralProgramDetailResponseSchema),
            update: contract_1.oc
                .route({
                method: "PUT",
                path: "/admin/v2/event-referral/programs/{id}",
            })
                .input(schemas_1.AdminV2EventReferralProgramUpdateInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
            delete: contract_1.oc
                .route({
                method: "DELETE",
                path: "/admin/v2/event-referral/programs/{id}",
            })
                .input(schemas_1.AdminV2EventReferralProgramIdInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
        }),
        codes: contract_1.oc.router({
            create: contract_1.oc
                .route({
                method: "POST",
                path: "/admin/v2/event-referral/codes",
            })
                .input(schemas_1.AdminV2EventReferralCodeCreateInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
            list: contract_1.oc
                .route({
                method: "GET",
                path: "/admin/v2/event-referral/codes",
            })
                .input(schemas_1.AdminListQuerySchema)
                .output(schemas_1.AdminReferralCodeListResponseSchema),
            detail: contract_1.oc
                .route({
                method: "GET",
                path: "/admin/v2/event-referral/codes/{id}",
            })
                .input(schemas_1.AdminV2EventReferralCodeIdInputSchema)
                .output(schemas_1.AdminReferralCodeDetailResponseSchema),
            update: contract_1.oc
                .route({
                method: "PUT",
                path: "/admin/v2/event-referral/codes/{id}",
            })
                .input(schemas_1.AdminV2EventReferralCodeUpdateInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
            delete: contract_1.oc
                .route({
                method: "DELETE",
                path: "/admin/v2/event-referral/codes/{id}",
            })
                .input(schemas_1.AdminV2EventReferralCodeIdInputSchema)
                .output(schemas_1.AdminActionResponseSchema),
        }),
    }),
    // Banking
    banking: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/banks" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminBankingAccountListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/banks/{public_address}" })
            .input(schemas_1.AdminV2BankingAddInputSchema)
            .output(schemas_1.AdminActionResponseSchema),
        delete: contract_1.oc
            .route({
            method: "DELETE",
            path: "/admin/v2/banks/{public_address}/{bank_uuid}",
        })
            .input(schemas_1.AdminV2BankingDeleteInputSchema)
            .output(schemas_1.AdminNoContentResponseSchema),
    }),
    // Spam Top-up
    spamTopup: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/admin/v2/spam-topup-list" })
            .input(schemas_1.AdminListQuerySchema)
            .output(schemas_1.AdminSpamTopupListResponseSchema),
        delete: contract_1.oc
            .route({ method: "POST", path: "/admin/v2/topup-spam/delete" })
            .input(schemas_1.AdminV2SpamTopupDeleteInputSchema)
            .output(schemas_1.AdminSpamTopupDeleteResponseSchema),
    }),
});
// ─── System ────────────────────────────────────────────────────────
const system = contract_1.oc.router({
    status: contract_1.oc
        .route({ method: "GET", path: "/system/status" })
        .input(schemas_1.AdminListQuerySchema.optional())
        .output(schemas_1.AdminSystemStatusListResponseSchema),
    updateStatus: contract_1.oc
        .route({ method: "POST", path: "/system/update-status" })
        .input(schemas_1.SystemUpdateStatusInputSchema)
        .output(schemas_1.AdminSystemStatusSchema),
});
// ─── Wallet V1 ─────────────────────────────────────────────────────
const wallet = contract_1.oc.router({
    // Auth
    register: contract_1.oc
        .route({ method: "POST", path: "/wallet/v1/register" })
        .input(schemas_1.WalletRegisterInputSchema)
        .output(schemas_1.GenericResponseSchema),
    auth: contract_1.oc
        .route({ method: "POST", path: "/wallet/v1/auth" })
        .input(schemas_1.WalletAuthInputSchema)
        .output(schemas_1.GenericResponseSchema),
    // Balance
    balance: contract_1.oc
        .route({ method: "GET", path: "/wallet/v1/balance" })
        .output(schemas_1.GenericResponseSchema),
    // Supported currencies
    supportedCurrencies: contract_1.oc
        .route({ method: "GET", path: "/wallet/v1/supported-currencies" })
        .output(schemas_1.GenericResponseSchema),
    // Exchange rate
    exchangeRate: contract_1.oc
        .route({ method: "GET", path: "/wallet/v1/exchange-rate" })
        .input(schemas_1.WalletExchangeRateInputSchema)
        .output(schemas_1.WalletExchangeRateResponseSchema),
    // Deposit address
    requestDepositAddress: contract_1.oc
        .route({ method: "POST", path: "/wallet/v1/request-deposit-address" })
        .input(schemas_1.WalletRequestDepositAddressInputSchema)
        .output(schemas_1.WalletRequestDepositAddressResponseSchema),
    // Transactions
    transactions: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/transactions" })
            .input(schemas_1.WalletTransactionListInputSchema)
            .output(schemas_1.GenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/transactions/{uuid}" })
            .input(schemas_1.WalletTransactionDetailInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // Ongoing transaction
    ongoingTransaction: contract_1.oc
        .route({ method: "GET", path: "/wallet/v1/ongoing-transaction" })
        .output(schemas_1.GenericResponseSchema),
    // Limits
    myLimit: contract_1.oc
        .route({ method: "GET", path: "/wallet/v1/my-limit" })
        .output(schemas_1.GenericResponseSchema),
    // Banking
    banking: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/bankings" })
            .output(schemas_1.BankAccountListResponseSchema),
        listPayment: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/bankings/payment" })
            .output(schemas_1.BankAccountListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/banking" })
            .input(schemas_1.WalletBankingAddInputSchema)
            .output(schemas_1.GenericResponseSchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/wallet/v1/banking/{bank_uuid}" })
            .input(schemas_1.WalletBankingEditInputSchema)
            .output(schemas_1.GenericResponseSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/wallet/v1/banking/{bank_uuid}" })
            .input(schemas_1.WalletBankingUuidInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // Address book
    address: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/address" })
            .output(schemas_1.GenericResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/address" })
            .input(schemas_1.WalletP2PAddressInputSchema)
            .output(schemas_1.GenericResponseSchema),
        edit: contract_1.oc
            .route({ method: "PUT", path: "/wallet/v1/address/{address_uuid}" })
            .input(schemas_1.WalletP2PAddressEditInputSchema)
            .output(schemas_1.GenericResponseSchema),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/wallet/v1/address/{address_uuid}" })
            .input(schemas_1.WalletP2PAddressUuidInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // Merchant
    merchant: contract_1.oc.router({
        get: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/merchant" })
            .output(schemas_1.WalletMerchantResponseSchema),
        create: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/merchant" })
            .input(schemas_1.WalletMerchantAddInputSchema)
            .output(schemas_1.WalletMerchantResponseSchema),
        update: contract_1.oc
            .route({ method: "PUT", path: "/wallet/v1/merchant" })
            .input(schemas_1.WalletMerchantEditInputSchema)
            .output(schemas_1.WalletMerchantResponseSchema),
        uploadImage: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/merchant/image" })
            .output(schemas_1.WalletMerchantUploadImageResponseSchema),
    }),
    // Escrow
    escrow: contract_1.oc.router({
        submitDeposit: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/escrow/submit-deposit" })
            .input(schemas_1.WalletEscrowSubmitDepositInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // Payment links
    paymentLink: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/payment-links" })
            .input(schemas_1.WalletTransactionListInputSchema)
            .output(schemas_1.GenericResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/payment-link/{payment_uuid}" })
            .input(schemas_1.WalletPaymentLinkDetailInputSchema)
            .output(schemas_1.GenericResponseSchema),
        create: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/payment-link" })
            .input(schemas_1.WalletPaymentLinkCreateInputSchema)
            .output(schemas_1.GenericResponseSchema),
        void: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/payment-link/void" })
            .input(schemas_1.WalletPaymentLinkVoidInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // PPOB
    ppob: contract_1.oc.router({
        services: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/ppob/services" })
            .output(schemas_1.GenericResponseSchema),
        products: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/ppob/products" })
            .input(schemas_1.WalletPpobProductListInputSchema)
            .output(schemas_1.GenericResponseSchema),
        mobileProviderValidate: contract_1.oc
            .route({
            method: "GET",
            path: "/wallet/v1/ppob/mobile-provider/validate",
        })
            .input(schemas_1.WalletPpobMobileProviderInputSchema)
            .output(schemas_1.GenericResponseSchema),
        plnInquiry: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/ppob/pln/inquiry" })
            .input(schemas_1.WalletPpobPlnInquiryInputSchema)
            .output(schemas_1.WalletPpobPlnInquiryResponseSchema),
        prepaidOrders: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/ppob/prepaid/orders" })
            .input(schemas_1.WalletPpobPrepaidOrderInputSchema)
            .output(schemas_1.WalletPpobOrderEscrowResponseSchema),
        postpaidInquiry: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/ppob/postpaid/inquiry" })
            .input(schemas_1.WalletPpobPostpaidInquiryInputSchema)
            .output(schemas_1.GenericResponseSchema),
        postpaidOrders: contract_1.oc
            .route({ method: "POST", path: "/wallet/v1/ppob/postpaid/orders" })
            .input(schemas_1.WalletPpobPostpaidOrderInputSchema)
            .output(schemas_1.WalletPpobOrderEscrowResponseSchema),
    }),
    // User restrictions
    user: contract_1.oc.router({
        restrictions: contract_1.oc
            .route({ method: "GET", path: "/wallet/v1/user/restrictions" })
            .output(schemas_1.GenericResponseSchema),
    }),
    // Migrations
    migrations: contract_1.oc.router({
        status: contract_1.oc
            .route({ method: "GET", path: "/wallet/migrations/status" })
            .output(schemas_1.WalletMigrationStatusResponseSchema),
        createUnsignedJs: contract_1.oc
            .route({ method: "POST", path: "/wallet/migrations/create-unsigned-js" })
            .output(schemas_1.WalletMigrationCreateUnsignedJsResponseSchema),
        returnJsMintSc: contract_1.oc
            .route({ method: "POST", path: "/wallet/migrations/return-js-mint-sc" })
            .output(schemas_1.WalletMigrationReturnJsMintScResponseSchema),
    }),
});
// ─── Wallet V2 ─────────────────────────────────────────────────────
const walletV2 = contract_1.oc.router({
    // Activities
    activities: contract_1.oc.router({
        list: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/activities" })
            .input(schemas_1.WalletV2ActivityListInputSchema)
            .output(schemas_1.WalletV2ActivityListResponseSchema),
        detail: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/activity/{activity_uuid}" })
            .input(schemas_1.WalletV2ActivityDetailInputSchema)
            .output(schemas_1.GenericResponseSchema),
    }),
    // Redeem
    redeem: contract_1.oc.router({
        initiate: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/redeem/initiate" })
            .input(schemas_1.WalletV2RedeemInitiateInputSchema)
            .output(schemas_1.WalletV2RedeemInitiateResponseSchema),
        toBank: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/redeem-to-bank/send" })
            .input(schemas_1.WalletV2RedeemBankSendInputSchema)
            .output(schemas_1.WalletV2RedeemSendResponseSchema),
        toEwallet: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/redeem-to-ewallet/send" })
            .input(schemas_1.WalletV2RedeemEwalletSendInputSchema)
            .output(schemas_1.WalletV2RedeemSendResponseSchema),
    }),
    // Pay
    pay: contract_1.oc.router({
        bankTransferFee: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/pay/bank_transfer/fee" })
            .output(schemas_1.WalletV2BankTransferFeeResponseSchema),
        bankTransferInitiate: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/pay/bank_transfer/initiate" })
            .input(schemas_1.WalletV2PayBankTransferInitiateInputSchema)
            .output(schemas_1.WalletV2PayBankTransferInitiateResponseSchema),
        bankTransferSend: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/pay/bank_transfer/send" })
            .input(schemas_1.WalletV2PayBankTransferSendInputSchema)
            .output(schemas_1.WalletV2PayBankTransferSendResponseSchema),
    }),
    // Transfer
    transfer: contract_1.oc.router({
        initiate: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/transfer/initiate" })
            .input(schemas_1.WalletV2TransferInitiateInputSchema)
            .output(schemas_1.WalletV2TransferInitiateResponseSchema),
        send: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/transfer/send" })
            .input(schemas_1.WalletV2TransferSendInputSchema)
            .output(schemas_1.WalletV2TransferSendResponseSchema),
    }),
    // Banking
    banking: contract_1.oc.router({
        supportedBanks: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/supported-banks" })
            .output(schemas_1.SupportedBankListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/banking" })
            .input(schemas_1.WalletV2BankingAddInputSchema)
            .output(zod_1.z.union([schemas_1.BankAccountResponseSchema, schemas_1.LegacyInvalidStatusResponseSchema])),
        update: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/banking/{bank_uuid}/update" })
            .input(schemas_1.WalletV2BankingEditInputSchema)
            .output(zod_1.z.union([schemas_1.BankAccountResponseSchema, schemas_1.LegacyInvalidStatusResponseSchema])),
        validation: contract_1.oc
            .route({
            method: "GET",
            path: "/v2/wallet/banking/{bank_uuid}/validation",
        })
            .input(schemas_1.WalletV2BankingUuidInputSchema)
            .output(schemas_1.BankAccountResponseSchema),
        favorite: contract_1.oc
            .route({
            method: "PATCH",
            path: "/v2/wallet/banking/{bank_uuid}/favorite",
        })
            .input(schemas_1.WalletV2BankingFavoriteInputSchema)
            .output(schemas_1.BankAccountResponseSchema),
    }),
    // E-wallet
    ewallet: contract_1.oc.router({
        supportedEwallets: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/supported-ewallet" })
            .output(schemas_1.SupportedEwalletListResponseSchema),
        list: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/ewallet-accounts" })
            .output(schemas_1.EwalletAccountListResponseSchema),
        add: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/ewallet-account" })
            .input(schemas_1.WalletV2EwalletAddInputSchema)
            .output(zod_1.z.union([
            schemas_1.EwalletAccountResponseSchema,
            schemas_1.LegacyInvalidStatusResponseSchema,
        ])),
        update: contract_1.oc
            .route({
            method: "POST",
            path: "/v2/wallet/ewallet-account/{uuid}/update",
        })
            .input(schemas_1.WalletV2EwalletEditInputSchema)
            .output(zod_1.z.union([
            schemas_1.EwalletAccountResponseSchema,
            schemas_1.LegacyInvalidStatusResponseSchema,
        ])),
        delete: contract_1.oc
            .route({ method: "DELETE", path: "/v2/wallet/ewallet-account/{uuid}" })
            .input(schemas_1.WalletV2EwalletUuidInputSchema)
            .output(schemas_1.NoContentResponseSchema),
        validation: contract_1.oc
            .route({
            method: "GET",
            path: "/v2/wallet/ewallet-account/{uuid}/validation",
        })
            .input(schemas_1.WalletV2EwalletUuidInputSchema)
            .output(schemas_1.EwalletAccountResponseSchema),
        favorite: contract_1.oc
            .route({
            method: "PATCH",
            path: "/v2/wallet/ewallet-account/{uuid}/favorite",
        })
            .input(schemas_1.WalletV2EwalletFavoriteInputSchema)
            .output(schemas_1.EwalletAccountResponseSchema),
    }),
    // Referral
    referral: contract_1.oc.router({
        submit: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/referral" })
            .input(schemas_1.WalletV2ReferralInputSchema)
            .output(schemas_1.WalletV2ReferralSubmitResponseSchema),
        journey: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/referral/journey" })
            .output(schemas_1.WalletV2ReferralJourneyResponseSchema),
        rewards: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/referral" })
            .output(schemas_1.WalletV2ReferralDetailsResponseSchema),
    }),
    // Virtual account
    virtualAccount: contract_1.oc.router({
        supported: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/supported-virtual-account" })
            .output(schemas_1.WalletV2VirtualAccountSupportedResponseSchema),
        topUpInstruction: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/top-up-bank-instruction" })
            .output(schemas_1.WalletV2VirtualAccountTopUpInstructionResponseSchema),
        create: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/virtual-account" })
            .input(schemas_1.WalletV2VirtualAccountInputSchema)
            .output(schemas_1.WalletV2VirtualAccountCreateResponseSchema),
    }),
    // KYC
    kyc: contract_1.oc.router({
        myDetail: contract_1.oc
            .route({ method: "POST", path: "/v2/wallet/kyc/my-detail" })
            .output(schemas_1.WalletV2KycDetailResponseSchema),
        benefits: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/kyc/benefits" })
            .output(schemas_1.WalletV2KycBenefitsResponseSchema),
        getAccessToken: contract_1.oc
            .route({ method: "GET", path: "/v2/wallet/kyc/get-access-token" })
            .input(schemas_1.WalletV2KycAccessTokenInputSchema)
            .output(schemas_1.WalletV2KycAccessTokenResponseSchema),
    }),
});
// ─── Root Contract ─────────────────────────────────────────────────
exports.contract = contract_1.oc.router({
    admin,
    adminV2,
    system,
    wallet,
    walletV2,
});
//# sourceMappingURL=contract.js.map